import { KommissionSearchResults } from '@/types/service-response'

export class SearchCommission {
  public constructor (
    readonly id: number,
    readonly kommissionNummer: string,
    readonly bezeichnung: string,
    readonly start: string,
    readonly end: string,
    readonly status: string,
    readonly adresse: string,
    readonly sachbearbeiterName: string,
    readonly sachbearbeiterVorname: string,
    readonly fullName: string,
    readonly fach: string,
    readonly bemerkungen: string,
    readonly genAdresse: string,
    readonly art: string | null,
    readonly artBezeichnung: string,
  ) {}

  static createFromResponse (item: KommissionSearchResults): SearchCommission {
    return new SearchCommission(
      item.ID,
      item.KommissionNummer ? item.KommissionNummer : '',
      item.Bezeichnung ? item.Bezeichnung : '',
      item.Start ? item.Start : '',
      item.Termin ? item.Termin : '',
      item.Status ? item.Status : '',
      item.Adresse ? item.Adresse : '',
      item.SachbearbeiterName ? item.SachbearbeiterName : '',
      item.SachbearbeiterVorname ? item.SachbearbeiterVorname : '',
      item.SachbearbeiterName && item.SachbearbeiterVorname ? `${item.SachbearbeiterVorname} ${item.SachbearbeiterName}` : '',
      item.Fach ? item.Fach : '',
      item.Bemerkungen ? item.Bemerkungen : '',
      item.GenAdresse ? item.GenAdresse : '',
      item.Art,
      item.ArtBezeichnung ? item.ArtBezeichnung : '',
    )
  }

  static createListFromResponse (responseData: KommissionSearchResults[]): Array<SearchCommission> {
    return responseData.map((item: KommissionSearchResults ) => {
      return new SearchCommission(
        item.ID,
        item.KommissionNummer ? item.KommissionNummer : '',
        item.Bezeichnung ? item.Bezeichnung : '',
        item.Start ? item.Start : '',
        item.Termin ? item.Termin : '',
        item.Status ? item.Status : '',
        item.Adresse ? item.Adresse : '',
        item.SachbearbeiterName ? item.SachbearbeiterName : '',
        item.SachbearbeiterVorname ? item.SachbearbeiterVorname : '',
        item.SachbearbeiterName && item.SachbearbeiterVorname ? `${item.SachbearbeiterVorname} ${item.SachbearbeiterName}` : '',
        item.Fach ? item.Fach : '',
        item.Bemerkungen ? item.Bemerkungen : '',
        item.GenAdresse ? item.GenAdresse : '',
        item.Art,
        item.ArtBezeichnung ? item.ArtBezeichnung : '',
      )
    })
  }
}
